import React, { useState, useEffect, useCallback } from "react";
import { getLoggedInUser } from "../helpers";
import { useNavigate } from 'react-router-dom';
import { Container, Card, CardBody, Col, Row, Table, Label, FormGroup, Button, Alert, Input } from "reactstrap";
import { AvForm, AvField, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import Betslip from "../components/Betslip";
import { useDispatch, useSelector } from "react-redux";
import { betSlipService } from '../redux/betslip/services';
import swal from 'sweetalert';
import Loader from "../components/Loader/Loader";
import config from 'react-global-configuration';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import addDays from 'date-fns/addDays'
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'moment';
import styles from "./auth/register.module.css";
import SmallLoader from '../components/SmallLoader/SmallLoader';
import { useTranslation } from 'react-i18next'; 

const EditAccounts = ({ setIsModalOpenOne }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = getLoggedInUser();
    const { t } = useTranslation();
    const [startDate, setStartDate] = useState(new Date());
    const [isLoading, setIsLoading] = useState(false);
    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [basic_info, setBasicInfo] = useState('');
    const [profile_img, setProfileImg] = useState('');
    const [regexp] = useState(/^[0-9\b]+$/);
    const [password, setPassword] = useState('');
    const [cnfm_password, setCnfmPassword] = useState('');
    const [userList, setUserList] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [images, setImages] = useState('');
    const [responseArray, setResponseArray] = useState([]);

    const loadRecordsTables = useCallback(() => {
        const reqData = { guid: user.guid };
        setIsLoading(true);
        betSlipService.fatchUserDetails(reqData).then((res) => {
            let data = res[0];
            setUserList(data);
            setIsLoading(false);
        });
    }, [user.guid]);

    useEffect(() => {
        loadRecordsTables();
    }, [loadRecordsTables]);

    const handleValidSubmit = (event, values) => {
        setIsLoading(true);
        let formData = new FormData();
        formData.append('user_id', values.user_id);
        formData.append('name', values.name);
        if (selectedFile) {
            for (let i = 0; i < selectedFile.length; i++) {
                formData.append("images[]", selectedFile[i], selectedFile[i].name);
            }
        }

        betSlipService.userdocumnet(formData, config).then((response) => {
            if (response.success) {
                swal({
                    title: "Success",
                    text: response.message,
                    icon: "success",
                    buttons: {
                        confirm: "Ok"
                    },
                    successMode: true,
                }).then((result) => {
                    if (result) {
                        setIsModalOpenOne(false);
                        // navigate('/user-profile');
                    }
                });
            } else {
                swal({
                    title: "Requires Attention.",
                    text: response.message,
                    icon: "info",
                    buttons: {
                        confirm: "Ok"
                    },
                    successMode: true,
                });
            }
        }).catch((error) => {
            setIsLoading(false);
            swal(error.response.message, {
                icon: "error",
            });
        });
        setIsLoading(false);
    };

    const handleFileChange = (e) => {
        setSelectedFile(Array.from(e.target.files));
    };

    const handleFileUpload = () => {
        if (selectedFile) {
            setSelectedFile(selectedFile);
        }
    };

    const handleSelectChange = (event) => {
        // Handle select change if needed
    };

    const renderRedirectToRoot = () => {
        // Handle redirection if needed
    };

    return (
        <React.Fragment>
            {/* {isLoading && <Loader />} */}
            {/* Add any error handling here */}
            {renderRedirectToRoot()}
            <div className="account-pages">
                <section>
                    <Container>
                        <Row className="justify-content-center">
                            <Col className="col-xl-12">
                                <div className="">
                                    <div className='card--body'>
                                        <AvForm onValidSubmit={handleValidSubmit}>
                                            <div className="col-md-12 mb-5">
                                                <h3 style={{ textAlign: "center" }} className="text-white">{t('userProfile.uploadDocument.modal.title')}</h3>
                                            </div>
                                            <div className="col-md-12">
                                                <AvGroup>
                                                    <Label style={{ color: '#fff' }} for="selectOption" className="mb-2 form-label text-white">{t('userProfile.uploadDocument.modal.selectOption')} <span className="text-danger">*</span></Label>
                                                    <AvInput
                                                        className="form--control style-two text-white"
                                                        accept=".pdf, image/*"
                                                        type="select"
                                                        name="name"
                                                        id="selectOption"
                                                        required
                                                        onChange={handleSelectChange}
                                                    >
                                                        <option value="">{t('userProfile.uploadDocument.modal.selectDocument')}</option>
                                                        <option value="passport">{t('userProfile.uploadDocument.modal.documentTypes.passport')}</option>
                                                        <option value="driving-license">{t('userProfile.uploadDocument.modal.documentTypes.drivingLicense')}</option>
                                                        <option value="text-document">{t('userProfile.uploadDocument.modal.documentTypes.textDocument')}</option>
                                                        <option value="proof-of-address">{t('userProfile.uploadDocument.modal.documentTypes.proofOfAddress')}</option>
                                                        <option value="proof-of-payment">{t('userProfile.uploadDocument.modal.documentTypes.proofOfPayment')}</option>
                                                        <option value="bank-statement">{t('userProfile.uploadDocument.modal.documentTypes.bankStatement')}</option>
                                                        <option value="payslips">{t('userProfile.uploadDocument.modal.documentTypes.paySlips')}</option>
                                                    </AvInput>
                                                    <AvFeedback>{t("userProfile.uploadDocument.modal.selectOption")}</AvFeedback>
                                                </AvGroup>
                                            </div>
                                            <br />
                                            <div className="col-md-12">
                                                <Label for="file" className="mb-2 form-label ">{t("userProfile.uploadDocument.modal.chooseDocument")} <span className="text-danger">*</span></Label>
                                                <AvField
                                                    className="chose-document"
                                                    type="file"
                                                    multiple
                                                    name="images"
                                                    accept=".pdf, image/*"
                                                    required
                                                    errorMessage={t("userProfile.uploadDocument.modal.fileError")}
                                                    onChange={handleFileChange}
                                                />

                                                {selectedFile && (
                                                    <div>
                                                        <span>{selectedFile[0].name}</span>
                                                    </div>
                                                )}
                                                {!selectedFile && (
                                                    <div>
                                                        <span className="error-message mt-2 text-white">{t('userProfile.uploadDocument.modal.fileSizeLimit')} </span>
                                                    </div>
                                                )}
                                            </div>
                                            <Row className="gy-3">
                                                <AvField type="hidden" name="user_id" id="guid" value={user.id || ''} />
                                                <div className="col-md-12 center">
                                                    <button disabled={isLoading} className="cstm_btn2 active mt-3 ">{t('userProfile.uploadDocument.modal.title')} </button>
                                                    {isLoading && <SmallLoader />}
                                                </div>
                                            </Row>
                                        </AvForm>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    const { user } = state.Auth;
    return { user };
};

export default connect(mapStateToProps)(EditAccounts);
